import { getCustomerColor } from './helpers/getCustomerColor'
import { getNames } from './helpers/getNames'

export const OrganizationContactCommon = {
  Helper: {
    getColor: getCustomerColor,
    getNames: getNames,
  },
}
